export enum AuthorizationStatus {
  ANALYSIS = 'ANALYSIS',
  AUTHORIZED = 'AUTHORIZED',
  FAILURE = 'FAILURE',
  DENIED = 'DENIED',
  CANCELED = 'CANCELED',
  PENDENCY = 'PENDENCY',
  PARTIALLY_AUTHORIZED = 'PARTIALLY_AUTHORIZED',
  PRE_AUTHORIZED = 'PRE_AUTHORIZED',
  NEGOTIATION = 'NEGOTIATION',
  REQUESTED = 'REQUESTED',
  NOT_REQUIRED_AUTHORIZATION = 'NOT_REQUIRED_AUTHORIZATION',
  REANALYSIS = 'REANALYSIS'
}

export enum AuthorizationStatusTranslated {
  ANALYSIS = 'Em análise',
  AUTHORIZED = 'Autorizado',
  FAILURE = 'Falha de autorização',
  DENIED = 'Negado',
  CANCELED = 'Cancelado',
  PENDENCY = 'Possui pendência',
  PARTIALLY_AUTHORIZED = 'Autorizado com divergência',
  PRE_AUTHORIZED = 'Pré-autorizado',
  NEGOTIATION = 'Em negociação',
  REQUESTED = 'Solicitado',
  NOT_REQUIRED_AUTHORIZATION = 'Não requer autorização',
  DONE = 'Realizada',
  REANALYSIS = 'Reanálise'
}
